import React, { useEffect, useState } from "react";
import { Text, Dialog, DialogType, Icon, Stack, PrimaryButton } from "@fluentui/react";
import { IPowerBiRefreshPermissionsResponse } from "../../api/generated";
import Loading from "../loading/Loading";
import { formatDateWithTime } from "../../shared/dateUtils";

export interface RefreshPermissionsDialogProps {
    refreshPermission: () => Promise<IPowerBiRefreshPermissionsResponse>;
};

const RefreshPermissionsDialog: React.FC<RefreshPermissionsDialogProps> = props => {

    const [refreshResponse, setRefreshResponse] = useState<IPowerBiRefreshPermissionsResponse>();

    useEffect(() => {
        const initialize = async () => {
            var respose = await props.refreshPermission();
            setRefreshResponse(respose);

        };
        initialize();
    }, []);
    
    const getIcon = () => {
        if (refreshResponse.isRefreshRequestedSuccessfully) {
            return <Icon iconName="CheckMark" style={{fontSize: 100, color: "green"}} />;
        }
        return <Icon iconName="Warning" style={{fontSize: 100, color: "red"}} />;
    }

    const getMessage = () => {
        if (refreshResponse.isRefreshRequestedSuccessfully) {
            return "Uprawnienia zostały odświeżone, ich prawidłowa propagacja może zająć kilka minut. Odśwież stronę, aby spróbować ponownie."
        }

        let message = "Możesz odświeżać uprawnienia nie częściej niż raz na godzinę. Poczekaj kilka minut następnie spróbuj ponownie odświeżyć stronę z raportem.";
        if (refreshResponse.lastRefresh) {
            message = message + ` Ostatnia próba odświeżenia uprawnień miała miejsce ${formatDateWithTime(refreshResponse.lastRefresh)}`
        }

        return message;
    }

    return (
        <Dialog hidden={false} dialogContentProps={{ type: DialogType.largeHeader, styles: { title: { padding: 0}}}}>
                {refreshResponse
                    ? 
                    <Stack tokens={{childrenGap: 20}} horizontalAlign="center">
                        {getIcon()}
                        <Stack horizontalAlign="center" verticalAlign="center" tokens={{childrenGap: 10}} styles={{root: {textAlign: "center"}}}>
                            <Text>{getMessage()}</Text>
                            <PrimaryButton text="Odśwież stronę" onClick={() => { window.location.reload() }} />
                        </Stack>
                    </Stack>
                    : <Loading description="Odświeżanie uprawnień" minHeight="60vh" />
                }
        </Dialog>
    );
};

export default RefreshPermissionsDialog;